// Marblet CRM — Main Application Entry Point

import { Auth } from "../Auth/Auth.js";
const auth = new Auth();
window.auth = auth;

import { Ajax } from "../Ajax/Ajax.js";
var ajax = new Ajax();
window.ajax = ajax;

import { VROC } from '../_VROC/VROC.js';
import { popupManager } from '../_VROC/PopupManager.js';

const vroc = new VROC();
window.vroc = vroc;
window.popupManager = popupManager;

// Получение ID заказа со страницы
function getInvoiceIdFromPage() {
	const urlParams = new URLSearchParams(window.location.search);
	const idFromUrl = urlParams.get('id');
	if (idFromUrl) return parseInt(idFromUrl);

	const orderIdElement = document.querySelector('#orderId');
	if (orderIdElement && orderIdElement.value) return parseInt(orderIdElement.value);

	const dataElement = document.querySelector('[data-invoice-id]');
	if (dataElement) {
		const idFromData = dataElement.getAttribute('data-invoice-id');
		if (idFromData) return parseInt(idFromData);
	}

	return null;
}

window.getInvoiceIdFromPage = getInvoiceIdFromPage;

/* === Utilities === */
const doc = document.documentElement;

function setAppSizes() {
	const windowHeight = window.innerHeight;
	doc.style.setProperty('--app-height', `${windowHeight}px`);
	const header = document.querySelector('.crm-header');
	if (header) doc.style.setProperty('--header-height', `${header.offsetHeight}px`);
}

function applyTouchClass() {
	const isTouch = 'ontouchstart' in window
		|| navigator.maxTouchPoints > 0
		|| navigator.msMaxTouchPoints > 0;
	document.body.classList.toggle('mob', isTouch);
	document.body.classList.toggle('des', !isTouch);
}

/* === Live Clock (Singapore Time) === */
function initClock() {
	const clocks = document.querySelectorAll('.crm-header__time, .crm-footer__clock');
	if (!clocks.length) return;

	function updateAll() {
		const now = new Date().toLocaleTimeString('en-GB', {
			hour: '2-digit', minute: '2-digit',
			timeZone: 'Asia/Singapore'
		});
		clocks.forEach(el => el.textContent = now);
	}

	updateAll();
	setInterval(updateAll, 60000);
}

/* === CRM Header Navigation === */
function initCRMNav() {
	const burger = document.querySelector('.crm-header__nav-burger');
	const menu = document.querySelector('.crm-main-nav');
	if (!burger || !menu) return;

	function toggle() {
		burger.classList.toggle('active');
		menu.classList.toggle('active');
	}
	function reset() {
		if (window.innerWidth >= 1024) {
			burger.classList.remove('active');
			menu.classList.remove('active');
		}
	}

	burger.addEventListener('click', toggle);
	window.addEventListener('resize', reset);
	reset();
}

/* === Tabs === */
function initTabs() {
	document.querySelectorAll('.tabs').forEach(container => {
		const btns = Array.from(container.querySelectorAll('.tabs__nav-btn'));
		const panes = Array.from(container.querySelectorAll('.tabs__tab'));
		if (!btns.length || !panes.length) return;

		btns.forEach(btn => {
			btn.addEventListener('click', () => {
				const key = btn.getAttribute('data-tab');
				btns.forEach(b => b.classList.remove('active'));
				panes.forEach(p => p.classList.remove('active'));

				container
					.querySelectorAll(`.tabs__nav-btn[data-tab="${key}"]`)
					.forEach(b => b.classList.add('active'));
				container
					.querySelectorAll(`.tabs__tab[data-tab="${key}"]`)
					.forEach(p => p.classList.add('active'));
			});
		});
	});
}

/* === Datepickers === */
import { initDatepickers } from '../CRM/Datepicker/Datepicker.js';

/* === TimePickers === */
import { initTimePickers } from '../CRM/TimePicker/TimePicker.js';

/* === Form Multi — event delegation, без повторного навешивания === */
function initFormMulti(container = document) {
	// Инициализация один раз на document через delegation
	if (document._formMultiInit) return;
	document._formMultiInit = true;

	// Клик вне — закрываем все
	document.addEventListener('click', e => {
		if (!e.target.closest('.form-multi')) {
			document.querySelectorAll('.form-multi.active').forEach(f => f.classList.remove('active'));
		}
	});

	// Предотвращаем blur при клике внутри dropdown
	document.addEventListener('mousedown', e => {
		if (e.target.closest('.form-multi__choice') && !e.target.closest('.form-multi__choice-label')) {
			e.preventDefault();
		}
	});

	// Выбор элемента из списка
	document.addEventListener('click', e => {
		const label = e.target.closest('.form-multi__choice-label');
		if (!label) return;

		e.preventDefault();
		const item = label.closest('.form-multi__choice-item');
		const form = label.closest('.form-multi');
		if (!form) return;

		const input = item ? item.querySelector('.form-multi__choice-input') : null;
		const topInput = form.querySelector('.form-multi__top-input');
		const hiddenInput = form.querySelector('input[type="hidden"]');

		// Get label text without hint
		const hint = label.querySelector('.form-multi__choice-hint');
		const labelText = hint
			? label.textContent.replace(hint.textContent, '').trim()
			: label.textContent.trim();
		const inputValue = input ? input.value : labelText;

		if (topInput) topInput.value = labelText;
		if (input) input.checked = true;

		if (hiddenInput) {
			hiddenInput.value = inputValue;
			hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
		}

		form.classList.remove('active');
	});

	// Focus на input — открытие списка
	document.addEventListener('focusin', e => {
		const topInput = e.target.closest('.form-multi__top-input');
		if (!topInput) return;

		const form = topInput.closest('.form-multi');
		if (!form) return;

		document.querySelectorAll('.form-multi.active').forEach(f => f.classList.remove('active'));
		form.classList.add('active');
		form.querySelectorAll('.form-multi__choice-item').forEach(item => item.style.display = '');
	});

	// Input — поиск
	document.addEventListener('input', e => {
		const topInput = e.target.closest('.form-multi__top-input');
		if (!topInput) return;

		const form = topInput.closest('.form-multi');
		if (!form) return;

		const searchText = topInput.value.toLowerCase().trim();
		form.querySelectorAll('.form-multi__choice-item').forEach(item => {
			const label = item.querySelector('.form-multi__choice-label');
			const labelText = label ? label.textContent.toLowerCase().trim() : '';
			item.style.display = labelText.includes(searchText) ? '' : 'none';
		});
	});

	// Blur — закрытие и восстановление
	document.addEventListener('focusout', e => {
		const topInput = e.target.closest('.form-multi__top-input');
		if (!topInput) return;

		const form = topInput.closest('.form-multi');
		if (!form) return;

		setTimeout(() => {
			if (!form.contains(document.activeElement)) {
				const hiddenInput = form.querySelector('input[type="hidden"]');
				const allowCustom = form.dataset.allowCustom === 'true';

				if (allowCustom) {
					// Custom mode — записываем введённый текст в hidden и dispatch
					if (hiddenInput && hiddenInput.value !== topInput.value) {
						hiddenInput.value = topInput.value;
						hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
					}
				} else {
					// Strict mode — восстанавливаем предыдущее значение
					if (hiddenInput && hiddenInput.value) {
						const checkedRadio = form.querySelector('.form-multi__choice-input:checked');
						if (checkedRadio) {
							const checkedLabel = checkedRadio.closest('.form-multi__choice-item')?.querySelector('.form-multi__choice-label');
							if (checkedLabel) topInput.value = checkedLabel.textContent.trim();
						}
					}
				}
				form.classList.remove('active');
			}
		}, 150);
	});
}

/* === Page-specific Components === */

import { Order } from "../CRM/Orders/Order.js";
import { Operation } from "../CRM/Operation/Operation.js";
import { CRM } from "../CRM/CRM.js";
import { SendManager } from "../CRM/Send/SendManager.js";

function initPageSpecificComponents() {
	const isOrderPage = document.querySelector('.page.order');
	const isOperationPage = document.querySelector('.page.operation');

	if (isOrderPage) {
		const orderInstance = new Order();
		window.order = orderInstance;

		const crmInstance = new CRM();
		crmInstance.init();
		window.crm = crmInstance;

		const sendManagerInstance = new SendManager();
		window.sendManager = sendManagerInstance;

		console.log('[App] Order page initialized');
	}

	if (isOperationPage) {
		const operationInstance = new Operation();
		window.operation = operationInstance;

		const crmInstance = new CRM();
		crmInstance.init();
		window.crm = crmInstance;

		const sendManagerInstance = new SendManager();
		window.sendManager = sendManagerInstance;

		console.log('[App] Operation page initialized');
	}
}

/* === Main App Init === */
function initApp() {
	setAppSizes();
	applyTouchClass();
	initClock();
	initCRMNav();
	initTabs();
	initDatepickers();
	initTimePickers();
	initFormMulti();

	// Инициализируем компоненты по страницам
	initPageSpecificComponents();

	// Попапы
	popupManager.init();
}

document.addEventListener('DOMContentLoaded', initApp);
window.addEventListener('resize', setAppSizes);

// Expose init functions globally for VROC rebind
window.initDatepickers = initDatepickers;
window.initFormMulti = initFormMulti;

export {
	initApp,
	popupManager,
	initDatepickers,
	initTabs,
	initFormMulti,
	getInvoiceIdFromPage
};
